import { RefreshCw, FileKey, Server, Handshake } from "lucide-react";
import { PortalLayout } from "../components/PortalLayout";

const revenueStreams = [
  {
    icon: Server,
    title: "Infrastructure Hosting Services",
    description: "Recurring revenue from enterprise hosting and managed infrastructure services for external clients.",
    details: "Provides stable, predictable income through long-term hosting contracts and service agreements.",
  },
  {
    icon: RefreshCw,
    title: "Subscription-Based Platforms",
    description: "Monthly and annual recurring revenue from platform access and usage fees.",
    details: "Scalable revenue model across all proprietary platforms with flexible pricing tiers.",
  },
  {
    icon: FileKey,
    title: "Software Licensing & White-Label Solutions",
    description: "Licensing of proprietary and partner platforms to third-party operators and organizations.",
    details: "Enables rapid market expansion without direct operational overhead while generating licensing fees.",
  },
  {
    icon: Handshake,
    title: "Strategic Partnerships",
    description: "Co-development agreements and revenue-sharing arrangements with institutional partners.",
    details: "Creates opportunities for joint ventures and collaborative growth initiatives.",
  },
];

export function CommercialModelPage() {
  return (
    <PortalLayout>

      {/* Header */}
      <div className="mb-14">
        <p className="text-xs font-semibold uppercase tracking-widest text-[#7B1A1A] mb-4">
          Commercial Model
        </p>
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-semibold text-[#1F2933] mb-8 leading-tight max-w-3xl">
          Diversified Revenue Architecture
        </h1>
        <p className="text-[#4B5563] max-w-4xl leading-relaxed">
          LEO Group generates revenue through a diversified model designed for both stability and scalability.
          This multi-stream approach ensures consistent income generation while enabling long-term growth across
          infrastructure services, platform subscriptions, software licensing, and strategic partnerships.
        </p>
      </div>

      {/* Info */}
      <div className="bg-[#FDEAE0]/60 border border-[#7B1A1A]/15 rounded-lg p-6 mb-14">
        <p className="text-sm text-[#4B5563] leading-relaxed">
          This multi-stream approach ensures consistent income generation while enabling long-term growth and market
          expansion across multiple sectors and client segments.
        </p>
      </div>

      {/* Revenue Streams */}
      <div className="grid md:grid-cols-2 gap-6 mb-14">
        {revenueStreams.map(({ icon: Icon, title, description, details }) => (
          <div key={title} className="bg-white border border-[#E5E7EB] rounded-lg p-8 shadow-sm">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-[#FDEAE0]/60 border border-[#7B1A1A]/15 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon className="w-6 h-6 text-[#7B1A1A]" />
              </div>
              <h3 className="text-sm font-semibold text-[#1F2933] leading-snug">{title}</h3>
            </div>
            <p className="text-sm text-[#4B5563] leading-relaxed mb-3">{description}</p>
            <p className="text-xs text-[#4B5563] leading-relaxed border-t border-[#E5E7EB] pt-3">{details}</p>
          </div>
        ))}
      </div>


    </PortalLayout>
  );
}
